export { ALLOWED_RARE_COUNTRIES } from './allowedCountries';

export const SOPHISTICATION_CONTENT = {
  head: 'ring.rare.sophistication.head',
  items: [
    {
      colA: `[A]`,
      colB: 'ring.rare.sophistication.accuracy.title',
      colC: 'ring.rare.sophistication.accuracy.description',
    },
    {
      colA: `[B]`,
      colB: 'ring.rare.sophistication.technology.title',
      colC: 'ring.rare.sophistication.technology.description',
    },
    {
      colA: `[C]`,
      colB: {
        headKey: 'ring.rare.sophistication.uhxAccess.title',
        descKey: 'ring.rare.sophistication.uhxAccess.description',
      },
      colC: {
        headKey: 'ring.rare.sophistication.powerPlugsAccess.title',
        descKey: 'ring.rare.sophistication.powerPlugsAccess.description',
      },
    },
  ],
};

export const BENEFITS_CONTENT = {
  head: 'ring.rare.benefits.head',
  image: true,
  noMargin: true,
  items: [
    {
      colA: `[A]`,
      colB: 'ring.rare.benefits.membership.title',
      colC: 'ring.rare.benefits.membership.description',
    },
    {
      colA: `[B]`,
      colB: 'ring.rare.benefits.prioritySupport.title',
      colC: 'ring.rare.benefits.prioritySupport.description',
    },
    {
      colA: `[C]`,
      colB: 'ring.rare.benefits.powerPlugs.title',
      colC: 'ring.rare.benefits.powerPlugs.description',
    },
    {
      colA: `[D]`,
      colB: 'ring.rare.benefits.sizeProtection.title',
      colC: 'ring.rare.benefits.sizeProtection.description',
    },
    {
      colA: `[E]`,
      colB: 'ring.rare.benefits.upgradeProgram.title',
      colC: 'ring.rare.benefits.upgradeProgram.description',
    },
    {
      colA: `[F]`,
      colB: 'ring.rare.benefits.replacementCoverage.title',
      colC: 'ring.rare.benefits.replacementCoverage.description',
    },
    {
      colA: null,
      colB: 'ring.rare.benefits.disclaimer.title',
      colC: 'ring.rare.benefits.disclaimer.description',
    },
  ],
};
